import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe2 } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Spinner, fmtNum } from "../components/common";
import MapView from "../components/MapView";
import { AppTopBar } from "../components/AppScreen";

export default function MapExplorer() {
  const [airports, setAirports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [includeMedium, setIncludeMedium] = useState(false);

  useEffect(() => {
    setLoading(true);
    const types = includeMedium ? "large_airport,medium_airport" : "large_airport";
    api.get("/map/airports", { params: { types } })
      .then((r) => setAirports(r.data))
      .finally(() => setLoading(false));
  }, [includeMedium]);

  const markers = airports.map((a) => ({
    lat: a.latitude,
    lon: a.longitude,
    radius: a.type === "large_airport" ? 4 : 2.5,
    popup: (
      <div className="text-sm">
        <div className="font-heading font-700">{a.name}</div>
        <div className="font-mono text-xs text-primary">{a.iata_code} · {a.iso_country}</div>
        <Link to={`/airports/${a.iata_code || a.id}`} className="text-primary underline text-xs">Open profile →</Link>
      </div>
    ),
  }));

  return (
    <div data-testid="map-page">
      <AppTopBar title="Maps" />
      <PageHeader eyebrow="Explore" title="World Airport Map"
        subtitle="Every major airport plotted from its real coordinates. Click a marker to open its profile.">
        <label className="inline-flex items-center gap-2 mt-4 text-sm cursor-pointer" data-testid="map-medium-toggle">
          <input type="checkbox" checked={includeMedium} onChange={(e) => setIncludeMedium(e.target.checked)} className="accent-primary" />
          Include medium airports (slower)
        </label>
      </PageHeader>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pb-16">
        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3 font-mono">
          <Globe2 className="w-4 h-4" /> {loading ? "loading…" : `${fmtNum(markers.length)} airports plotted`}
        </div>
        {loading ? <Spinner /> : <MapView markers={markers} height="72vh" center={[25, 10]} zoom={2} />}
      </div>
    </div>
  );
}
